import { useTranslations } from "next-intl";

import { Link } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import { LOG_STREAMS_PATH } from "@zapier/reporting/src/constants";

export function StreamZapRunsButton() {
  const t = useTranslations("history-page");

  return (
    <Link
      href={LOG_STREAMS_PATH}
      iconPosition="start"
      size="medium"
      variant="tertiary"
    >
      <Icon aria-hidden={true} name="statusStatus" />
      {t("stream-zap-runs")}
    </Link>
  );
}
